const AUDIO_METADATA_TIMEOUT_MS = 3000;
const fileAttachmentMeta = new WeakMap();
export const setFileAttachmentMeta = (file, meta) => {
    fileAttachmentMeta.set(file, meta);
};
export const getFileAttachmentMeta = (file) => fileAttachmentMeta.get(file);
const readAudioDurationMs = (file) => {
    if (typeof document === "undefined" || !file.type.startsWith("audio/")) {
        return Promise.resolve(undefined);
    }
    return new Promise((resolve) => {
        const audio = document.createElement("audio");
        const objectUrl = window.URL.createObjectURL(file);
        let settled = false;
        const cleanup = () => {
            audio.removeAttribute("src");
            audio.load();
            window.URL.revokeObjectURL(objectUrl);
        };
        const finish = (durationMs) => {
            if (settled)
                return;
            settled = true;
            window.clearTimeout(timeoutId);
            cleanup();
            resolve(durationMs);
        };
        const timeoutId = window.setTimeout(() => finish(undefined), AUDIO_METADATA_TIMEOUT_MS);
        audio.preload = "metadata";
        audio.onloadedmetadata = () => {
            const duration = audio.duration;
            finish(Number.isFinite(duration) && duration > 0
                ? Math.round(duration * 1000)
                : undefined);
        };
        audio.onerror = () => finish(undefined);
        audio.src = objectUrl;
    });
};
export const getFilePreviewKind = (file) => {
    if (file.type.startsWith("audio/"))
        return "audio";
    if (file.type.startsWith("image/"))
        return "image";
    return "file";
};
export const buildDisplayAttachmentMeta = (file) => ({
    sizeBytes: file.size,
    previewKind: getFilePreviewKind(file),
    ...(getFileAttachmentMeta(file) ?? {}),
});
export const buildAttachmentMeta = async (file) => {
    const durationMs = await readAudioDurationMs(file);
    return {
        ...buildDisplayAttachmentMeta(file),
        ...(durationMs !== undefined ? { durationMs } : {}),
    };
};
